import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectIsThemedEventJoined, selectThemedEvent, selectThemedEventDifficultyLevelUnlocked, selectThemedEventIsQuestsCompleted, selectThemedEventIsRewardCollected, } from "../../../selectors/selectEventInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionThemedEventStartRequest, TypeActionThemedEvent } from "../actionThemedEvent";
export var epicThemedEventBuildingClicked = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionThemedEvent.BuildingClicked), switchMap(function () {
        var state = state$.value;
        var themedEvent = selectThemedEvent(state);
        var difficultyLevelUnlocked = selectThemedEventDifficultyLevelUnlocked(state);
        if (selectThemedEventIsQuestsCompleted(state)) {
            var modalId = selectThemedEventIsRewardCollected(state)
                ? IdModal.ThemedEvent
                : IdModal.ThemedEventReward;
            return of(actionModalOpen(modalId));
        }
        if (selectIsThemedEventJoined(state)) {
            return of(actionModalOpen(IdModal.ThemedEvent));
        }
        var eventId = themedEvent.eventId;
        return difficultyLevelUnlocked === 1 && eventId
            ? of(actionThemedEventStartRequest(eventId, difficultyLevelUnlocked))
            : of(actionModalOpen(IdModal.ThemedEventDifficulty));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEventBuildingClicked.ts
// module id = 2421
// module chunks = 3